import React, { FC } from 'react';
import { StripeBaseBox } from './StripeBaseBox';
import { BlueCTAButton } from '../Common';
import injectStore from 'src/util/injectStore';
import { AppStore } from 'src/stores/AppStore';
import { useTrackPaymentsViewedEvent } from 'src/payments/hooks/useTrackPaymentsViewedEvent';
import { PaymentEventActivePaymentProvider, PaymentEventComponent } from 'src/payments/types';
import { getPaymentEventSource } from 'src/payments/utils';

export const StripeInitialBoxComponent: FC<{ onCTAClick: () => void; store: AppStore }> = ({
  onCTAClick,
  store
}) => {
  const paymentsViewedMeta = {
    source: getPaymentEventSource(),
    activePaymentProvider: PaymentEventActivePaymentProvider.STRIPE,
    component: PaymentEventComponent.tileInitial
  };

  useTrackPaymentsViewedEvent(paymentsViewedMeta, store.user.events);

  return (
    <>
      <div data-testid="stripeInitialBox" />
      <StripeBaseBox actionElement={<BlueCTAButton onClick={onCTAClick}>Set Up</BlueCTAButton>} />
    </>
  );
};

export const StripeInitialBox = injectStore(StripeInitialBoxComponent);
